import _ from 'lodash';
import { hideWithStars } from '../utils/transformTitle'

export const allKCGraphData = {
  nodes: [
    {
      id: '11-KC00',
      style: { label: { value: '수의 크기 비교' } },
      properties: {
        uid: '11-KC00',
        _KK_importerId: 'aMOlFKaAWk',
        title: '수의 크기 비교',
      },
    },
    {
      id: '11-KC01',
      style: { label: { value: '전체에 대한 부분의 크기를 분수로 나타내기' } },
      properties: {
        uid: '11-KC01',
        _KK_importerId: 'aMOlFKaAWk',
        title: '전체에 대한 부분의 크기를 분수로 나타내기',
      },
    },
    {
      id: '11-KC02',
      style: { label: { value: '단위분수로 나타내기' } },
      properties: {
        uid: '11-KC02',
        _KK_importerId: 'aMOlFKaAWk',
        title: '단위분수로 나타내기',
      },
    },
    {
      id: '11-KC03',
      style: { label: { value: '부분은 전체의 얼마인지 분수로 나타내기' } },
      properties: {
        uid: '11-KC03',
        _KK_importerId: 'aMOlFKaAWk',
        title: '부분은 전체의 얼마인지 분수로 나타내기',
      },
    },
    {
      id: '11-KC04',
      style: { label: { value: '전체의 1/■이 얼마인지 구하기' } },
      properties: {
        uid: '11-KC04',
        _KK_importerId: 'aMOlFKaAWk',
        title: '전체의 1/■이 얼마인지 구하기',
      },
    },
    {
      id: '11-KC05',
      style: { label: { value: '전체의 ▲/■가 얼마인지 구하기' } },
      properties: {
        uid: '11-KC05',
        _KK_importerId: 'aMOlFKaAWk',
        title: '전체의 ▲/■가 얼마인지 구하기',
      },
    },
    {
      id: '11-KC06',
      style: { label: { value: '진분수, 가분수, 대분수 분류하기' } },
      properties: {
        uid: '11-KC06',
        _KK_importerId: 'aMOlFKaAWk',
        title: '진분수, 가분수, 대분수 분류하기',
      },
    },
    {
      id: '11-KC07',
      style: { label: { value: '분수를 수직선에 나타내기' } },
      properties: {
        uid: '11-KC07',
        _KK_importerId: 'aMOlFKaAWk',
        title: '분수를 수직선에 나타내기',
      },
    },
    {
      id: '11-KC08',
      style: {
        label: { value: '자연수를 가분수로, 가분수를 자연수로 나타내기' },
      },
      properties: {
        uid: '11-KC08',
        _KK_importerId: 'aMOlFKaAWk',
        title: '자연수를 가분수로, 가분수를 자연수로 나타내기',
      },
    },
    {
      id: '11-KC09',
      style: { label: { value: '대분수를 가분수로 나타내기' } },
      properties: {
        uid: '11-KC09',
        _KK_importerId: 'aMOlFKaAWk',
        title: '대분수를 가분수로 나타내기',
      },
    },
    {
      id: '11-KC10',
      style: { label: { value: '가분수를 대분수로 나타내기' } },
      properties: {
        uid: '11-KC10',
        _KK_importerId: 'aMOlFKaAWk',
        title: '가분수를 대분수로 나타내기',
      },
    },
    {
      id: '11-KC11',
      style: { label: { value: '분모가 같은 진분수의 크기 비교' } },
      properties: {
        uid: '11-KC11',
        _KK_importerId: 'aMOlFKaAWk',
        title: '분모가 같은 진분수의 크기 비교',
      },
    },
    {
      id: '11-KC12',
      style: { label: { value: '단위분수의 크기 비교' } },
      properties: {
        uid: '11-KC12',
        _KK_importerId: 'aMOlFKaAWk',
        title: '단위분수의 크기 비교',
      },
    },
    {
      id: '11-KC13',
      style: { label: { value: '분모가 같은 가분수의 크기 비교' } },
      properties: {
        uid: '11-KC13',
        _KK_importerId: 'aMOlFKaAWk',
        title: '분모가 같은 가분수의 크기 비교',
      },
    },
    {
      id: '11-KC14',
      style: { label: { value: '분모가 같은 대분수의 크기 비교' } },
      properties: {
        uid: '11-KC14',
        _KK_importerId: 'aMOlFKaAWk',
        title: '분모가 같은 대분수의 크기 비교',
      },
    },
    {
      id: '11-KC15',
      style: { label: { value: '분모가 같은 가분수와 대분수의 크기 비교' } },
      properties: {
        uid: '11-KC15',
        _KK_importerId: 'aMOlFKaAWk',
        title: '분모가 같은 가분수와 대분수의 크기 비교',
      },
    },
    {
      id: '11-KC16',
      style: {
        label: { value: '합이 1보다 작고 분모가 같은 (진분수)+(진분수)' },
      },
      properties: {
        uid: '11-KC16',
        _KK_importerId: 'aMOlFKaAWk',
        title: '합이 1보다 작고 분모가 같은 (진분수)+(진분수)',
      },
    },
    {
      id: '11-KC17',
      style: {
        label: {
          value:
            '합이 1보다 크고 분모가 같은 (진분수)+(진분수), (가분수)+(진분수)',
        },
      },
      properties: {
        uid: '11-KC17',
        _KK_importerId: 'aMOlFKaAWk',
        title:
          '합이 1보다 크고 분모가 같은 (진분수)+(진분수), (가분수)+(진분수)',
      },
    },
    {
      id: '11-KC18',
      style: {
        label: {
          value:
            '진분수 부분의 합이 1보다 작고 분모가 같은 (자연수)+(대분수), (진분수)+(대분수), (대분수)+(대분수)',
        },
      },
      properties: {
        uid: '11-KC18',
        _KK_importerId: 'aMOlFKaAWk',
        title:
          '진분수 부분의 합이 1보다 작고 분모가 같은 (자연수)+(대분수), (진분수)+(대분수), (대분수)+(대분수)',
      },
    },
    {
      id: '11-KC19',
      style: {
        label: {
          value:
            '진분수 부분의 합이 1보다 크고 분모가 같은 (대분수)+(진분수), (대분수)+(대분수)',
        },
      },
      properties: {
        uid: '11-KC19',
        _KK_importerId: 'aMOlFKaAWk',
        title:
          '진분수 부분의 합이 1보다 크고 분모가 같은 (대분수)+(진분수), (대분수)+(대분수)',
      },
    },
    {
      id: '11-KC20',
      style: { label: { value: '분모가 같은 (대분수)+(가분수)' } },
      properties: {
        uid: '11-KC20',
        _KK_importerId: 'aMOlFKaAWk',
        title: '분모가 같은 (대분수)+(가분수)',
      },
    },
    {
      id: '11-KC21',
      style: {
        label: { value: '분모가 같은 (진분수)-(진분수), (가분수)-(진분수)' },
      },
      properties: {
        uid: '11-KC21',
        _KK_importerId: 'aMOlFKaAWk',
        title: '분모가 같은 (진분수)-(진분수), (가분수)-(진분수)',
      },
    },
    {
      id: '11-KC22',
      style: {
        label: {
          value:
            '분모가 같고 받아내림이 없는 (대분수)-(대분수), (대분수)-(진분수), (대분수)-(자연수)',
        },
      },
      properties: {
        uid: '11-KC22',
        _KK_importerId: 'aMOlFKaAWk',
        title:
          '분모가 같고 받아내림이 없는 (대분수)-(대분수), (대분수)-(진분수), (대분수)-(자연수)',
      },
    },
    {
      id: '11-KC23',
      style: { label: { value: '(자연수)-(진분수)' } },
      properties: {
        uid: '11-KC23',
        _KK_importerId: 'aMOlFKaAWk',
        title: '(자연수)-(진분수)',
      },
    },
    {
      id: '11-KC24',
      style: { label: { value: '(자연수)-(대분수)' } },
      properties: {
        uid: '11-KC24',
        _KK_importerId: 'aMOlFKaAWk',
        title: '(자연수)-(대분수)',
      },
    },
    {
      id: '11-KC25',
      style: {
        label: {
          value:
            '분모가 같고 받아내림이 있는 (대분수)-(진분수), (대분수)-(대분수)',
        },
      },
      properties: {
        uid: '11-KC25',
        _KK_importerId: 'aMOlFKaAWk',
        title:
          '분모가 같고 받아내림이 있는 (대분수)-(진분수), (대분수)-(대분수)',
      },
    },
    {
      id: '11-KC26',
      style: {
        label: { value: '분모가 같고 받아내림이 있는 (대분수)-(가분수)' },
      },
      properties: {
        uid: '11-KC26',
        _KK_importerId: 'aMOlFKaAWk',
        title: '분모가 같고 받아내림이 있는 (대분수)-(가분수)',
      },
    },
    {
      id: '11-KC27',
      style: { label: { value: '분모가 같은 세 분수의 덧셈과 뺄셈' } },
      properties: {
        uid: '11-KC27',
        _KK_importerId: 'aMOlFKaAWk',
        title: '분모가 같은 세 분수의 덧셈과 뺄셈',
      },
    },
    {
      id: '11-KC28',
      style: { label: { value: '소수 한 자리 수 알기' } },
      properties: {
        uid: '11-KC28',
        _KK_importerId: 'aMOlFKaAWk',
        title: '소수 한 자리 수 알기',
      },
    },
    {
      id: '11-KC29',
      style: { label: { value: '소수 한 자리 수의 크기 비교' } },
      properties: {
        uid: '11-KC29',
        _KK_importerId: 'aMOlFKaAWk',
        title: '소수 한 자리 수의 크기 비교',
      },
    },
    {
      id: '11-KC30',
      style: { label: { value: '소수 두 자리 수 알기' } },
      properties: {
        uid: '11-KC30',
        _KK_importerId: 'aMOlFKaAWk',
        title: '소수 두 자리 수 알기',
      },
    },
    {
      id: '11-KC31',
      style: { label: { value: '소수 두 자리 수의 크기 비교' } },
      properties: {
        uid: '11-KC31',
        _KK_importerId: 'aMOlFKaAWk',
        title: '소수 두 자리 수의 크기 비교',
      },
    },
    {
      id: '11-KC32',
      style: { label: { value: '소수 세 자리 수 알기' } },
      properties: {
        uid: '11-KC32',
        _KK_importerId: 'aMOlFKaAWk',
        title: '소수 세 자리 수 알기',
      },
    },
    {
      id: '11-KC33',
      style: { label: { value: '소수 세 자리 수의 크기 비교' } },
      properties: {
        uid: '11-KC33',
        _KK_importerId: 'aMOlFKaAWk',
        title: '소수 세 자리 수의 크기 비교',
      },
    },
    {
      id: '11-KC34',
      style: { label: { value: '소수 사이의 관계' } },
      properties: {
        uid: '11-KC34',
        _KK_importerId: 'aMOlFKaAWk',
        title: '소수 사이의 관계',
      },
    },
    {
      id: '11-KC35',
      style: { label: { value: '단위 사이의 관계' } },
      properties: {
        uid: '11-KC35',
        _KK_importerId: 'aMOlFKaAWk',
        title: '단위 사이의 관계',
      },
    },
    {
      id: '11-KC36',
      style: { label: { value: '약수 구하기' } },
      properties: {
        uid: '11-KC36',
        _KK_importerId: 'aMOlFKaAWk',
        title: '약수 구하기',
      },
    },
    {
      id: '11-KC37',
      style: { label: { value: '배수 구하기' } },
      properties: {
        uid: '11-KC37',
        _KK_importerId: 'aMOlFKaAWk',
        title: '배수 구하기',
      },
    },
    {
      id: '11-KC38',
      style: { label: { value: '약수와 배수의 관계' } },
      properties: {
        uid: '11-KC38',
        _KK_importerId: 'aMOlFKaAWk',
        title: '약수와 배수의 관계',
      },
    },
    {
      id: '11-KC39',
      style: { label: { value: '자연수를 여러 수의 곱으로 나타내기' } },
      properties: {
        uid: '11-KC39',
        _KK_importerId: 'aMOlFKaAWk',
        title: '자연수를 여러 수의 곱으로 나타내기',
      },
    },
    {
      id: '11-KC40',
      style: { label: { value: '약수를 구하여 공약수와 최대공약수 구하기' } },
      properties: {
        uid: '11-KC40',
        _KK_importerId: 'aMOlFKaAWk',
        title: '약수를 구하여 공약수와 최대공약수 구하기',
      },
    },
    {
      id: '11-KC41',
      style: { label: { value: '배수를 구하여 공배수와 최소공배수 구하기' } },
      properties: {
        uid: '11-KC41',
        _KK_importerId: 'aMOlFKaAWk',
        title: '배수를 구하여 공배수와 최소공배수 구하기',
      },
    },
    {
      id: '11-KC42',
      style: { label: { value: '곱셈식을 이용하여 최대공약수 구하기' } },
      properties: {
        uid: '11-KC42',
        _KK_importerId: 'aMOlFKaAWk',
        title: '곱셈식을 이용하여 최대공약수 구하기',
      },
    },
    {
      id: '11-KC43',
      style: { label: { value: '두 수의 최대공약수 구하기' } },
      properties: {
        uid: '11-KC43',
        _KK_importerId: 'aMOlFKaAWk',
        title: '두 수의 최대공약수 구하기',
      },
    },
    {
      id: '11-KC44',
      style: { label: { value: '곱셈식을 이용하여 최소공배수 구하기' } },
      properties: {
        uid: '11-KC44',
        _KK_importerId: 'aMOlFKaAWk',
        title: '곱셈식을 이용하여 최소공배수 구하기',
      },
    },
    {
      id: '11-KC45',
      style: { label: { value: '두 수의 최소공배수 구하기' } },
      properties: {
        uid: '11-KC45',
        _KK_importerId: 'aMOlFKaAWk',
        title: '두 수의 최소공배수 구하기',
      },
    },
    {
      id: '11-KC46',
      style: { label: { value: '그림을 이용하여 크기가 같은 분수 만들기' } },
      properties: {
        uid: '11-KC46',
        _KK_importerId: 'aMOlFKaAWk',
        title: '그림을 이용하여 크기가 같은 분수 만들기',
      },
    },
    {
      id: '11-KC47',
      style: { label: { value: '곱셈을 이용하여 크기가 같은 분수 만들기' } },
      properties: {
        uid: '11-KC47',
        _KK_importerId: 'aMOlFKaAWk',
        title: '곱셈을 이용하여 크기가 같은 분수 만들기',
      },
    },
    {
      id: '11-KC48',
      style: { label: { value: '나눗셈을 이용하여 크기가 같은 분수 만들기' } },
      properties: {
        uid: '11-KC48',
        _KK_importerId: 'aMOlFKaAWk',
        title: '나눗셈을 이용하여 크기가 같은 분수 만들기',
      },
    },
    {
      id: '11-KC49',
      style: { label: { value: '2, 3으로 약분하기' } },
      properties: {
        uid: '11-KC49',
        _KK_importerId: 'aMOlFKaAWk',
        title: '2, 3으로 약분하기',
      },
    },
    {
      id: '11-KC50',
      style: { label: { value: '5, 7로 약분하기' } },
      properties: {
        uid: '11-KC50',
        _KK_importerId: 'aMOlFKaAWk',
        title: '5, 7로 약분하기',
      },
    },
    {
      id: '11-KC51',
      style: { label: { value: '2~9로 약분하기' } },
      properties: {
        uid: '11-KC51',
        _KK_importerId: 'aMOlFKaAWk',
        title: '2~9로 약분하기',
      },
    },
    {
      id: '11-KC52',
      style: { label: { value: '10~19로 약분하기' } },
      properties: {
        uid: '11-KC52',
        _KK_importerId: 'aMOlFKaAWk',
        title: '10~19로 약분하기',
      },
    },
    {
      id: '11-KC53',
      style: { label: { value: '20~39로 약분하기' } },
      properties: {
        uid: '11-KC53',
        _KK_importerId: 'aMOlFKaAWk',
        title: '20~39로 약분하기',
      },
    },
    {
      id: '11-KC54',
      style: { label: { value: '두 분모의 곱을 공통분모로 하여 통분하기' } },
      properties: {
        uid: '11-KC54',
        _KK_importerId: 'aMOlFKaAWk',
        title: '두 분모의 곱을 공통분모로 하여 통분하기',
      },
    },
    {
      id: '11-KC55',
      style: {
        label: { value: '분모의 최소공배수를 공통분모로 하여 통분하기' },
      },
      properties: {
        uid: '11-KC55',
        _KK_importerId: 'aMOlFKaAWk',
        title: '분모의 최소공배수를 공통분모로 하여 통분하기',
      },
    },
    {
      id: '11-KC56',
      style: { label: { value: '두 분수의 크기 비교' } },
      properties: {
        uid: '11-KC56',
        _KK_importerId: 'aMOlFKaAWk',
        title: '두 분수의 크기 비교',
      },
    },
    {
      id: '11-KC57',
      style: { label: { value: '세 분수의 크기 비교' } },
      properties: {
        uid: '11-KC57',
        _KK_importerId: 'aMOlFKaAWk',
        title: '세 분수의 크기 비교',
      },
    },
  ],
  edges: [
    { source: '11-KC00', target: '11-KC56' },
    { source: '11-KC00', target: '11-KC57' },
    { source: '11-KC00', target: '11-KC13' },
    { source: '11-KC00', target: '11-KC11' },
    { source: '11-KC00', target: '11-KC15' },
    { source: '11-KC00', target: '11-KC14' },
    { source: '11-KC00', target: '11-KC06' },
    { source: '11-KC00', target: '11-KC12' },
    { source: '11-KC01', target: '11-KC02' },
    { source: '11-KC01', target: '11-KC46' },
    { source: '11-KC01', target: '11-KC03' },
    { source: '11-KC01', target: '11-KC04' },
    { source: '11-KC02', target: '11-KC12' },
    { source: '11-KC02', target: '11-KC06' },
    { source: '11-KC02', target: '11-KC28' },
    { source: '11-KC02', target: '11-KC16' },
    { source: '11-KC02', target: '11-KC03' },
    { source: '11-KC02', target: '11-KC21' },
    { source: '11-KC02', target: '11-KC05' },
    { source: '11-KC03', target: '11-KC05' },
    { source: '11-KC03', target: '11-KC04' },
    { source: '11-KC03', target: '11-KC08' },
    { source: '11-KC04', target: '11-KC07' },
    { source: '11-KC04', target: '11-KC05' },
    { source: '11-KC05', target: '11-KC07' },
    { source: '11-KC07', target: '11-KC11' },
    { source: '11-KC07', target: '11-KC10' },
    { source: '11-KC07', target: '11-KC08' },
    { source: '11-KC07', target: '11-KC09' },
    { source: '11-KC08', target: '11-KC14' },
    { source: '11-KC08', target: '11-KC24' },
    { source: '11-KC08', target: '11-KC09' },
    { source: '11-KC08', target: '11-KC13' },
    { source: '11-KC08', target: '11-KC10' },
    { source: '11-KC08', target: '11-KC23' },
    { source: '11-KC09', target: '11-KC10' },
    { source: '11-KC09', target: '11-KC22' },
    { source: '11-KC09', target: '11-KC24' },
    { source: '11-KC09', target: '11-KC20' },
    { source: '11-KC09', target: '11-KC26' },
    { source: '11-KC10', target: '11-KC17' },
    { source: '11-KC10', target: '11-KC20' },
    { source: '11-KC10', target: '11-KC22' },
    { source: '11-KC10', target: '11-KC19' },
    { source: '11-KC10', target: '11-KC14' },
    { source: '11-KC10', target: '11-KC15' },
    { source: '11-KC10', target: '11-KC26' },
    { source: '11-KC13', target: '11-KC15' },
    { source: '11-KC13', target: '11-KC14' },
    { source: '11-KC14', target: '11-KC15' },
    { source: '11-KC16', target: '11-KC17' },
    { source: '11-KC16', target: '11-KC18' },
    { source: '11-KC17', target: '11-KC19' },
    { source: '11-KC18', target: '11-KC19' },
    { source: '11-KC19', target: '11-KC20' },
    { source: '11-KC19', target: '11-KC27' },
    { source: '11-KC20', target: '11-KC27' },
    { source: '11-KC21', target: '11-KC22' },
    { source: '11-KC21', target: '11-KC23' },
    { source: '11-KC22', target: '11-KC25' },
    { source: '11-KC22', target: '11-KC24' },
    { source: '11-KC23', target: '11-KC25' },
    { source: '11-KC24', target: '11-KC25' },
    { source: '11-KC25', target: '11-KC26' },
    { source: '11-KC25', target: '11-KC27' },
    { source: '11-KC26', target: '11-KC27' },
    { source: '11-KC28', target: '11-KC29' },
    { source: '11-KC28', target: '11-KC32' },
    { source: '11-KC28', target: '11-KC34' },
    { source: '11-KC28', target: '11-KC30' },
    { source: '11-KC29', target: '11-KC31' },
    { source: '11-KC29', target: '11-KC33' },
    { source: '11-KC30', target: '11-KC34' },
    { source: '11-KC30', target: '11-KC32' },
    { source: '11-KC30', target: '11-KC31' },
    { source: '11-KC31', target: '11-KC33' },
    { source: '11-KC32', target: '11-KC34' },
    { source: '11-KC32', target: '11-KC33' },
    { source: '11-KC34', target: '11-KC35' },
    { source: '11-KC36', target: '11-KC39' },
    { source: '11-KC36', target: '11-KC49' },
    { source: '11-KC36', target: '11-KC48' },
    { source: '11-KC36', target: '11-KC42' },
    { source: '11-KC36', target: '11-KC38' },
    { source: '11-KC36', target: '11-KC50' },
    { source: '11-KC36', target: '11-KC43' },
    { source: '11-KC36', target: '11-KC40' },
    { source: '11-KC37', target: '11-KC54' },
    { source: '11-KC37', target: '11-KC44' },
    { source: '11-KC37', target: '11-KC41' },
    { source: '11-KC37', target: '11-KC47' },
    { source: '11-KC37', target: '11-KC45' },
    { source: '11-KC37', target: '11-KC38' },
    { source: '11-KC39', target: '11-KC45' },
    { source: '11-KC39', target: '11-KC42' },
    { source: '11-KC39', target: '11-KC40' },
    { source: '11-KC39', target: '11-KC44' },
    { source: '11-KC39', target: '11-KC43' },
    { source: '11-KC42', target: '11-KC43' },
    { source: '11-KC43', target: '11-KC53' },
    { source: '11-KC43', target: '11-KC52' },
    { source: '11-KC43', target: '11-KC49' },
    { source: '11-KC43', target: '11-KC51' },
    { source: '11-KC43', target: '11-KC50' },
    { source: '11-KC44', target: '11-KC45' },
    { source: '11-KC45', target: '11-KC55' },
    { source: '11-KC47', target: '11-KC54' },
    { source: '11-KC47', target: '11-KC55' },
    { source: '11-KC49', target: '11-KC51' },
    { source: '11-KC50', target: '11-KC51' },
    { source: '11-KC51', target: '11-KC53' },
    { source: '11-KC51', target: '11-KC52' },
    { source: '11-KC52', target: '11-KC53' },
    { source: '11-KC55', target: '11-KC57' },
    { source: '11-KC55', target: '11-KC56' },
    { source: '11-KC56', target: '11-KC57' },
  ],
};

const kcPosition = {
  '11-KC00': {
    x: 152.72635625481377,
    y: 213.1431587439369,
  },
  '11-KC01': {
    x: 145.11288588214632,
    y: 25.03599027123263,
  },
  '11-KC02': {
    x: 39.69437451189438,
    y: 146.26472286445397,
  },
  '11-KC03': {
    x: -72.45872884314478,
    y: -26.659603699565128,
  },
  '11-KC04': {
    x: -29.877149776359218,
    y: 174.73184120898284,
  },
  '11-KC05': {
    x: -184.84078859651348,
    y: 86.59981081975141,
  },
  '11-KC06': {
    x: 75.79012666797786,
    y: 383.2011631202486,
  },
  '11-KC07': {
    x: 46.76503348227922,
    y: -30.078100197429617,
  },
  '11-KC08': {
    x: -53.48761317219896,
    y: -197.1342505954845,
  },
  '11-KC09': {
    x: 73.32311179777939,
    y: -266.1913133284529,
  },
  '11-KC10': {
    x: 222.3766188448842,
    y: -205.84686611558487,
  },
  '11-KC11': {
    x: 266.31881215070314,
    y: 99.52678559092482,
  },
  '11-KC12': {
    x: -17.366964284495715,
    y: 345.80590157419135,
  },
  '11-KC13': {
    x: -2.702504774801847,
    y: 49.82079560413907,
  },
  '11-KC14': {
    x: 114.70008359504246,
    y: -63.694322184295714,
  },
  '11-KC15': {
    x: 241.22824881023286,
    y: 19.176901141984477,
  },
  '11-KC16': {
    x: 332.1548134891345,
    y: 45.75705375858036,
  },
  '11-KC17': {
    x: 426.9170091156169,
    y: -146.23389435686693,
  },
  '11-KC18': {
    x: 517.6800273751077,
    y: -113.7148001260334,
  },
  '11-KC19': {
    x: 437.00701612767284,
    y: -335.9452885865694,
  },
  '11-KC20': {
    x: 266.47406328024164,
    y: -384.6258096399752,
  },
  '11-KC21': {
    x: 42.10413980184,
    y: -155.26423542976264,
  },
  '11-KC22': {
    x: 120.6535251284556,
    y: -396.9323121682367,
  },
  '11-KC23': {
    x: 4.718652062230969,
    y: -386.66681664205475,
  },
  '11-KC24': {
    x: -75.48457281229308,
    y: -430.68938409421196,
  },
  '11-KC25': {
    x: 97.35645382350488,
    y: -586.831038520711,
  },
  '11-KC26': {
    x: 203.71901929328178,
    y: -429.04632276987905,
  },
  '11-KC27': {
    x: 340.6653243817817,
    y: -561.7163483004349,
  },
  '11-KC28': {
    x: -177.84578867802355,
    y: 334.86619120061306,
  },
  '11-KC29': {
    x: -260.58409216774106,
    y: 559.7084244990067,
  },
  '11-KC30': {
    x: -190.08879734560708,
    y: 501.0321842387405,
  },
  '11-KC31': {
    x: -398.55886849124283,
    y: 420.7860731709401,
  },
  '11-KC32': {
    x: -373.73637169359495,
    y: 354.64489694566265,
  },
  '11-KC33': {
    x: -483.12628116217513,
    y: 569.4422450985373,
  },
  '11-KC34': {
    x: -355.56862793770324,
    y: 540.4286209956288,
  },
  '11-KC35': {
    x: -382.0151533635366,
    y: 757.3325587795457,
  },
  '11-KC36': {
    x: 1005.6006642807006,
    y: 644.8012038467064,
  },
  '11-KC37': {
    x: 582.4513799594843,
    y: 871.5540940756129,
  },
  '11-KC38': {
    x: 819.7129753642153,
    y: 800.4333800812057,
  },
  '11-KC39': {
    x: 831.6448423687976,
    y: 618.4738415123066,
  },
  '11-KC40': {
    x: 933.7605699258005,
    y: 822.4115425911737,
  },
  '11-KC41': {
    x: 589.5329541135058,
    y: 1085.2025828211674,
  },
  '11-KC42': {
    x: 863.4626542616091,
    y: 445.7265097384535,
  },
  '11-KC43': {
    x: 1041.2453384732326,
    y: 456.5205903824376,
  },
  '11-KC44': {
    x: 734.7480246198852,
    y: 788.3722350643906,
  },
  '11-KC45': {
    x: 600.9129762697984,
    y: 648.7204067485649,
  },
  '11-KC46': {
    x: 333.12380015504027,
    y: -85.86320538986918,
  },
  '11-KC47': {
    x: 396.924458364411,
    y: 770.8527287923189,
  },
  '11-KC48': {
    x: 1138.420442732676,
    y: 815.8041780134067,
  },
  '11-KC49': {
    x: 1183.930844916454,
    y: 605.68192941113,
  },
  '11-KC50': {
    x: 1227.9586732810922,
    y: 556.8361619386781,
  },
  '11-KC51': {
    x: 1205.4190019058294,
    y: 379.3623320128958,
  },
  '11-KC52': {
    x: 1150.229127267238,
    y: 218.56698855285117,
  },
  '11-KC53': {
    x: 989.1207696029965,
    y: 275.95007784985984,
  },
  '11-KC54': {
    x: 398.45732707074393,
    y: 976.4678032122008,
  },
  '11-KC55': {
    x: 398.88663383900496,
    y: 554.6134769627462,
  },
  '11-KC56': {
    x: 356.4776039668825,
    y: 336.3875054305116,
  },
  '11-KC57': {
    x: 208.5408740322532,
    y: 446.90670029803397,
  },
};

// transform KC titles for graph
(()=>{
  const transformGraphTitles = (nodes) => _.map(nodes, ({ style: {label}, properties }) => {
    properties.title=hideWithStars(properties.title, 8)
    label.value=properties.title
  })
  transformGraphTitles(allKCGraphData.nodes)
})()

export const allKCGraphDataWithPosition = {
  nodes: _.map(allKCGraphData.nodes, (n) => ({
    ...n,
    x: kcPosition[n.id].x,
    y: kcPosition[n.id].y,
  })),
  edges: _.map(allKCGraphData.edges, (e) => ({
    ...e,
    id: e.source + e.target,
  })),
};

// console.log(allKCGraphDataWithPosition);

// _.map(x.nodes, (n) => {
//   return {
//     id : n.properties.uid,
//     label: {
//       value: n.properties.title
//     },
//     properties: n.properties
//   }
// });

// _.map(x.edges, e => {
//   return {
//     source : _.find(x.nodes, n => n.id === e.source).properties.uid,
//     target : _.find(x.nodes, n => n.id === e.target).properties.uid,
//   }
// });
// export const allKCGraphDataFromKK = {
//   nodes: [
//     {
//       id: '94663',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC00',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '수의 크기 비교',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n수의 크기 비교',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94664',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC01',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '전체에 대한 부분의 크기를 분수로 나타내기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n전체에 대한 부분의 크기를 분수로 나타내기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94665',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC02',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '단위분수로 나타내기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n단위분수로 나타내기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94666',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC03',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '부분은 전체의 얼마인지 분수로 나타내기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n부분은 전체의 얼마인지 분수로 나타내기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94667',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC04',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '전체의 1/■이 얼마인지 구하기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n전체의 1/■이 얼마인지 구하기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94668',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC05',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '전체의 ▲/■가 얼마인지 구하기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n전체의 ▲/■가 얼마인지 구하기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94669',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC06',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '진분수, 가분수, 대분수 분류하기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n진분수, 가분수, 대분수 분류하기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94670',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC07',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '분수를 수직선에 나타내기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n분수를 수직선에 나타내기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94671',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC08',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '자연수를 가분수로, 가분수를 자연수로 나타내기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n자연수를 가분수로, 가분수를 자연수로 나타내기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94672',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC09',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '대분수를 가분수로 나타내기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n대분수를 가분수로 나타내기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94673',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC10',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '가분수를 대분수로 나타내기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n가분수를 대분수로 나타내기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94674',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC11',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '분모가 같은 진분수의 크기 비교',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n분모가 같은 진분수의 크기 비교',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94675',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC12',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '단위분수의 크기 비교',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n단위분수의 크기 비교',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94676',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC13',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '분모가 같은 가분수의 크기 비교',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n분모가 같은 가분수의 크기 비교',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94677',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC14',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '분모가 같은 대분수의 크기 비교',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n분모가 같은 대분수의 크기 비교',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94678',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC15',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '분모가 같은 가분수와 대분수의 크기 비교',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n분모가 같은 가분수와 대분수의 크기 비교',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94679',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC16',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '합이 1보다 작고 분모가 같은 (진분수)+(진분수)',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n합이 1보다 작고 분모가 같은 (진분수)+(진분수)',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94680',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC17',
//         _KK_importerId: 'aMOlFKaAWk',
//         title:
//           '합이 1보다 크고 분모가 같은 (진분수)+(진분수), (가분수)+(진분수)',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value:
//             'KC\n합이 1보다 크고 분모가 같은 (진분수)+(진분수), (가분수)+(진분수)',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94681',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC18',
//         _KK_importerId: 'aMOlFKaAWk',
//         title:
//           '진분수 부분의 합이 1보다 작고 분모가 같은 (자연수)+(대분수), (진분수)+(대분수), (대분수)+(대분수)',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value:
//             'KC\n진분수 부분의 합이 1보다 작고 분모가 같은 (자연수)+(대분수), (진분수)+(대분수), (대분수)+(대분수)',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94682',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC19',
//         _KK_importerId: 'aMOlFKaAWk',
//         title:
//           '진분수 부분의 합이 1보다 크고 분모가 같은 (대분수)+(진분수), (대분수)+(대분수)',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value:
//             'KC\n진분수 부분의 합이 1보다 크고 분모가 같은 (대분수)+(진분수), (대분수)+(대분수)',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94683',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC20',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '분모가 같은 (대분수)+(가분수)',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n분모가 같은 (대분수)+(가분수)',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94684',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC21',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '분모가 같은 (진분수)-(진분수), (가분수)-(진분수)',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n분모가 같은 (진분수)-(진분수), (가분수)-(진분수)',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94685',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC22',
//         _KK_importerId: 'aMOlFKaAWk',
//         title:
//           '분모가 같고 받아내림이 없는 (대분수)-(대분수), (대분수)-(진분수), (대분수)-(자연수)',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value:
//             'KC\n분모가 같고 받아내림이 없는 (대분수)-(대분수), (대분수)-(진분수), (대분수)-(자연수)',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94686',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC23',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '(자연수)-(진분수)',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n(자연수)-(진분수)',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94687',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC24',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '(자연수)-(대분수)',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n(자연수)-(대분수)',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94688',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC25',
//         _KK_importerId: 'aMOlFKaAWk',
//         title:
//           '분모가 같고 받아내림이 있는 (대분수)-(진분수), (대분수)-(대분수)',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value:
//             'KC\n분모가 같고 받아내림이 있는 (대분수)-(진분수), (대분수)-(대분수)',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94689',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC26',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '분모가 같고 받아내림이 있는 (대분수)-(가분수)',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n분모가 같고 받아내림이 있는 (대분수)-(가분수)',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94690',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC27',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '분모가 같은 세 분수의 덧셈과 뺄셈',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n분모가 같은 세 분수의 덧셈과 뺄셈',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94691',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC28',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '소수 한 자리 수 알기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n소수 한 자리 수 알기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94692',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC29',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '소수 한 자리 수의 크기 비교',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n소수 한 자리 수의 크기 비교',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94693',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC30',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '소수 두 자리 수 알기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n소수 두 자리 수 알기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94694',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC31',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '소수 두 자리 수의 크기 비교',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n소수 두 자리 수의 크기 비교',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94695',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC32',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '소수 세 자리 수 알기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n소수 세 자리 수 알기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94696',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC33',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '소수 세 자리 수의 크기 비교',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n소수 세 자리 수의 크기 비교',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94697',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC34',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '소수 사이의 관계',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n소수 사이의 관계',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94698',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC35',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '단위 사이의 관계',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n단위 사이의 관계',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94699',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC36',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '약수 구하기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n약수 구하기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94700',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC37',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '배수 구하기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n배수 구하기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94701',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC38',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '약수와 배수의 관계',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n약수와 배수의 관계',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94702',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC39',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '자연수를 여러 수의 곱으로 나타내기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n자연수를 여러 수의 곱으로 나타내기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94703',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC40',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '약수를 구하여 공약수와 최대공약수 구하기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n약수를 구하여 공약수와 최대공약수 구하기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94704',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC41',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '배수를 구하여 공배수와 최소공배수 구하기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n배수를 구하여 공배수와 최소공배수 구하기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94705',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC42',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '곱셈식을 이용하여 최대공약수 구하기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n곱셈식을 이용하여 최대공약수 구하기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94706',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC43',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '두 수의 최대공약수 구하기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n두 수의 최대공약수 구하기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94707',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC44',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '곱셈식을 이용하여 최소공배수 구하기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n곱셈식을 이용하여 최소공배수 구하기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94708',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC45',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '두 수의 최소공배수 구하기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n두 수의 최소공배수 구하기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94709',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC46',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '그림을 이용하여 크기가 같은 분수 만들기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n그림을 이용하여 크기가 같은 분수 만들기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94710',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC47',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '곱셈을 이용하여 크기가 같은 분수 만들기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n곱셈을 이용하여 크기가 같은 분수 만들기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94711',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC48',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '나눗셈을 이용하여 크기가 같은 분수 만들기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n나눗셈을 이용하여 크기가 같은 분수 만들기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94712',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC49',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '2, 3으로 약분하기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n2, 3으로 약분하기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94713',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC50',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '5, 7로 약분하기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n5, 7로 약분하기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94714',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC51',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '2~9로 약분하기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n2~9로 약분하기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94715',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC52',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '10~19로 약분하기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n10~19로 약분하기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94716',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC53',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '20~39로 약분하기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n20~39로 약분하기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94717',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC54',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '두 분모의 곱을 공통분모로 하여 통분하기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n두 분모의 곱을 공통분모로 하여 통분하기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94718',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC55',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '분모의 최소공배수를 공통분모로 하여 통분하기',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n분모의 최소공배수를 공통분모로 하여 통분하기',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94719',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC56',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '두 분수의 크기 비교',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n두 분수의 크기 비교',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//     {
//       id: '94720',
//       kkSchemaName: 'KC',
//       properties: {
//         uid: '11-KC57',
//         _KK_importerId: 'aMOlFKaAWk',
//         title: '세 분수의 크기 비교',
//       },
//       style: {
//         keyshape: {
//           fill: '#E93B81',
//           stroke: '#E93B81',
//         },
//         icon: {
//           value: 'KC\n세 분수의 크기 비교',
//           fill: '#333',
//           size: 10,
//         },
//       },
//     },
//   ],
//   edges: [
//     {
//       id: 'e_29796',
//       source: '94663',
//       target: '94719',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29798',
//       source: '94663',
//       target: '94720',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29708',
//       source: '94663',
//       target: '94676',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29704',
//       source: '94663',
//       target: '94674',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29714',
//       source: '94663',
//       target: '94678',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29710',
//       source: '94663',
//       target: '94677',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29693',
//       source: '94663',
//       target: '94669',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29706',
//       source: '94663',
//       target: '94675',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29685',
//       source: '94664',
//       target: '94665',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29777',
//       source: '94664',
//       target: '94709',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29686',
//       source: '94664',
//       target: '94666',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29688',
//       source: '94664',
//       target: '94667',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29707',
//       source: '94665',
//       target: '94675',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29694',
//       source: '94665',
//       target: '94669',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29747',
//       source: '94665',
//       target: '94691',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29718',
//       source: '94665',
//       target: '94679',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29687',
//       source: '94665',
//       target: '94666',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29728',
//       source: '94665',
//       target: '94684',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29690',
//       source: '94665',
//       target: '94668',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29691',
//       source: '94666',
//       target: '94668',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29689',
//       source: '94666',
//       target: '94667',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29697',
//       source: '94666',
//       target: '94671',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29695',
//       source: '94667',
//       target: '94670',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29692',
//       source: '94667',
//       target: '94668',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29696',
//       source: '94668',
//       target: '94670',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29705',
//       source: '94670',
//       target: '94674',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29701',
//       source: '94670',
//       target: '94673',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29698',
//       source: '94670',
//       target: '94671',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29699',
//       source: '94670',
//       target: '94672',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29711',
//       source: '94671',
//       target: '94677',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29734',
//       source: '94671',
//       target: '94687',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29700',
//       source: '94671',
//       target: '94672',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29709',
//       source: '94671',
//       target: '94676',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29702',
//       source: '94671',
//       target: '94673',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29732',
//       source: '94671',
//       target: '94686',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29703',
//       source: '94672',
//       target: '94673',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29729',
//       source: '94672',
//       target: '94685',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29735',
//       source: '94672',
//       target: '94687',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29725',
//       source: '94672',
//       target: '94683',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29740',
//       source: '94672',
//       target: '94689',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29719',
//       source: '94673',
//       target: '94680',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29726',
//       source: '94673',
//       target: '94683',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29730',
//       source: '94673',
//       target: '94685',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29722',
//       source: '94673',
//       target: '94682',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29712',
//       source: '94673',
//       target: '94677',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29715',
//       source: '94673',
//       target: '94678',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29741',
//       source: '94673',
//       target: '94689',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29716',
//       source: '94676',
//       target: '94678',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29713',
//       source: '94676',
//       target: '94677',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29717',
//       source: '94677',
//       target: '94678',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29720',
//       source: '94679',
//       target: '94680',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29721',
//       source: '94679',
//       target: '94681',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29723',
//       source: '94680',
//       target: '94682',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29724',
//       source: '94681',
//       target: '94682',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29727',
//       source: '94682',
//       target: '94683',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29743',
//       source: '94682',
//       target: '94690',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29744',
//       source: '94683',
//       target: '94690',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29731',
//       source: '94684',
//       target: '94685',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29733',
//       source: '94684',
//       target: '94686',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29737',
//       source: '94685',
//       target: '94688',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29736',
//       source: '94685',
//       target: '94687',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29738',
//       source: '94686',
//       target: '94688',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29739',
//       source: '94687',
//       target: '94688',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29742',
//       source: '94688',
//       target: '94689',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29745',
//       source: '94688',
//       target: '94690',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29746',
//       source: '94689',
//       target: '94690',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29748',
//       source: '94691',
//       target: '94692',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29752',
//       source: '94691',
//       target: '94695',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29757',
//       source: '94691',
//       target: '94697',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29749',
//       source: '94691',
//       target: '94693',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29750',
//       source: '94692',
//       target: '94694',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29754',
//       source: '94692',
//       target: '94696',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29758',
//       source: '94693',
//       target: '94697',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29753',
//       source: '94693',
//       target: '94695',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29751',
//       source: '94693',
//       target: '94694',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29755',
//       source: '94694',
//       target: '94696',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29759',
//       source: '94695',
//       target: '94697',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29756',
//       source: '94695',
//       target: '94696',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29760',
//       source: '94697',
//       target: '94698',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29763',
//       source: '94699',
//       target: '94702',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29780',
//       source: '94699',
//       target: '94712',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29779',
//       source: '94699',
//       target: '94711',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29767',
//       source: '94699',
//       target: '94705',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29761',
//       source: '94699',
//       target: '94701',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29782',
//       source: '94699',
//       target: '94713',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29769',
//       source: '94699',
//       target: '94706',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29764',
//       source: '94699',
//       target: '94703',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29792',
//       source: '94700',
//       target: '94717',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29772',
//       source: '94700',
//       target: '94707',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29766',
//       source: '94700',
//       target: '94704',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29778',
//       source: '94700',
//       target: '94710',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29774',
//       source: '94700',
//       target: '94708',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29762',
//       source: '94700',
//       target: '94701',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29775',
//       source: '94702',
//       target: '94708',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29768',
//       source: '94702',
//       target: '94705',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29765',
//       source: '94702',
//       target: '94703',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29773',
//       source: '94702',
//       target: '94707',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29770',
//       source: '94702',
//       target: '94706',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29771',
//       source: '94705',
//       target: '94706',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29789',
//       source: '94706',
//       target: '94716',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29787',
//       source: '94706',
//       target: '94715',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29781',
//       source: '94706',
//       target: '94712',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29784',
//       source: '94706',
//       target: '94714',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29783',
//       source: '94706',
//       target: '94713',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29776',
//       source: '94707',
//       target: '94708',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29794',
//       source: '94708',
//       target: '94718',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29793',
//       source: '94710',
//       target: '94717',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29795',
//       source: '94710',
//       target: '94718',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29785',
//       source: '94712',
//       target: '94714',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29786',
//       source: '94713',
//       target: '94714',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29790',
//       source: '94714',
//       target: '94716',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29788',
//       source: '94714',
//       target: '94715',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29791',
//       source: '94715',
//       target: '94716',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29799',
//       source: '94718',
//       target: '94720',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29797',
//       source: '94718',
//       target: '94719',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//     {
//       id: 'e_29800',
//       source: '94719',
//       target: '94720',
//       kkSchemaName: 'PREREQUISITEOF',
//       style: {
//         label: {
//           value: 'PREREQUISITEOF',
//         },
//       },
//       properties: {
//         relType: 'directed',
//       },
//     },
//   ],
// };
